import 'angular';

import { DealerTermsAndConditionsCtrl } from './dealer.terms-and-conditions';
import { DealerService }                from './dealer.service';

angular.module('workshop.dealers', [])
  .controller('DealerTermsAndConditionsCtrl', DealerTermsAndConditionsCtrl)
  .factory('Dealer', DealerService)